<template>
  <div class="my-course">
    <a-card>
      <s-table
        :loading="confirmLoading"
        :columns="columns"
        :data="loadData"
        :scroll="{ x:1280 }"
        class="scroll-table-wrap"
        ref="table"
        rowKey="id"
        size="default"
      >
        <template slot="courseData" slot-scope="text, record, index">
          <span>{{ record.startDate + '~' + record.finishDate }}</span>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleCancel(record)" v-if="showCancelClass(record)">取消选课</a>
          <!-- 显示支付按钮：支付状态为未支付、已选课、支付方式为线上 -->
          <a-divider type="vertical" v-if="showCancelClass(record) && showPay(record)"/>
          <a @click="handlePay(record)" v-if="showPay(record)">支付</a>

          <a @click="handleTakeClass(record)" v-if="showTakeClass(record)">去上课</a>
          <a-divider type="vertical" v-if="showTakeClass(record) && showAdjustCourse(record)"/>
          <!-- 显示调课申请按钮：支付状态为已支付、调课审批状态为空或调课审批状态为不同意的、调课截止日期大于等于当前日期、未调课或调课次数小于等于3次（父id数量小于3） -->
          <a @click="handleAdjust(record)" v-if="showAdjustCourse(record)">调课申请</a>
<!--          <a-divider type="vertical" v-if="showAdjustCourse(record) && showAdjustDetail(record)"/>-->
          <!-- 显示调课详情按钮：支付状态为已支付、存在调课审批进度的 -->
          <a @click="handleDetail(record)" v-if="showAdjustDetail(record)">调课详情</a>
        </span>
      </s-table>
      <adjust-course-detail ref="adjustCourseDetail" />
    </a-card>
  </div>
</template>
<script>
  import moment from 'moment'
  import STable from '@/components/table/'
  import { mapState } from 'vuex'
  import { getListByCode } from '@/api/dict'
  import myCourse from '../../api/myCourse'
  import AdjustCourseDetail from './adjustCourse/AdjustCourseDetail'

  export default {
    name: 'TestPaper',
    components: {
      STable,
      AdjustCourseDetail
    },
    data() {
      return {
        nowDate: moment(new Date()).format('YYYY-MM-DD'),
        dictCode: 'payStatus,payType,wholeCourseStudentStatus,approveStatus',
        options: {},
        confirmLoading: false,
        columns: [
          {
            title: '课程日期',
            dataIndex: 'courseData',
            scopedSlots: { customRender: 'courseData' },
            className: 'min-wid-large'
          },
          {
            title: '课程体系',
            dataIndex: 'wholeName',
            ellipsis: true,
            className: 'min-wid-large'
          },
          {
            // 支付状态
            title: '支付状态',
            dataIndex: 'payStatus',
            ellipsis: true,
            className: 'min-wid-small',
            customRender: text => {
              const target = this.options.payStatus && this.options.payStatus.filter(item => text === item.value)[0]
              return target && target.label
            }
          },
          {
            // 支付方式
            title: '支付方式',
            dataIndex: 'payType',
            ellipsis: true,
            className: 'min-wid-small',
            customRender: text => {
              const target = this.options.payType && this.options.payType.filter(item => text === item.value)[0]
              return target && target.label
            }
          },
          {
            // 学时
            title: '学时',
            dataIndex: 'classHour',
            ellipsis: true,
            className: 'min-wid-xs'
          },
          {
            // 状态
            title: '状态',
            dataIndex: 'status',
            ellipsis: true,
            className: 'min-wid-small',
            customRender: text => {
              const target = this.options.wholeCourseStudentStatus && this.options.wholeCourseStudentStatus.filter(item => text === item.value)[0]
              return target && target.label
            }
          },
          {
            // 调课审批进度
            title: '调课审批进度',
            dataIndex: 'approveStatus',
            ellipsis: true,
            className: 'min-wid-sm',
            customRender: text => {
              const target = this.options.approveStatus && this.options.approveStatus.filter(item => text === item.value)[0]
              return target && target.label
            }
          },
          {
            // 选课时间
            title: '选课时间',
            dataIndex: 'chooseTime',
            className: 'min-wid-large',
          },
          {
            title: '操作',
            dataIndex: 'action',
            className: 'min-wid-middle',
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          const transferQuery = {}
          const order = parameter.sortOrder !== undefined ? parameter.sortOrder.substring(0, parameter.sortOrder.length - 3) : ''
          const page = {
            pageNo: parameter.pageNo,
            pageSize: parameter.pageSize,
            sortField: parameter.sortField,
            draw: order
          }
          return myCourse.getMyCourseList(Object.assign(transferQuery, page))
        }
      }
    },
    computed: {
      ...mapState({
        userData: state => {
          if (state.user.userData.name) {
            return state.user.userData
          } else {
            return JSON.parse(localStorage.getItem('user'))
          }
        }
      })
    },
    filters: {},
    methods: {
      openNotificationWithIcon(type, msg, description) {
        this.$notification[type]({
          message: msg,
          description: description
        })
      },
      showTakeClass(record) {
        return record.status === '1' && record.payStatus === '2' && (!record.approveStatus || (!record.approveStatus || record.approveStatus === '2'))
      },
      showCancelClass(record) {
        return record.status === '1' && record.payStatus === '1'
      },
      showPay(record) {
        return record.status === '1' && record.payStatus === '1' && record.payType === '1'
      },
      showAdjustCourse(record) {
        return record.status === '1'
          && record.payStatus === '2'
          && (!record.approveStatus || record.approveStatus === '2')
          && record.reassignCutoffDate >= this.nowDate
          && (!record.parentIds || record.parentIds.split(',').length < 3)
      },
      showAdjustDetail(record) {
        return record.payStatus === '2' && record.approveStatus
      },
      handleTakeClass(record) {
        this.$router.push('/home/myCourse/takeClass')
        sessionStorage.setItem('wholeCourseId', record.wholeCourseId)
      },
      handleAdjust(record) {
        sessionStorage.setItem('wholeId', record.wholeId)
        // 当前课程日期学时数
        sessionStorage.setItem('adjustCourseHour', record.classHour)
        // 当前课程日期id
        sessionStorage.setItem('sourceWholeCourseId', record.wholeCourseId)
        // 当前选课记录Id
        sessionStorage.setItem('wholeCourseStudentId', record.id)
        // 当前选课日期
        sessionStorage.setItem('sourceWholeCourseDate', record.startDate + '~' + record.finishDate)
        this.$router.push('/home/myCourse/adjustCourse')
      },
      handleDetail(record) {
        this.$refs.adjustCourseDetail.show(record.lastWholeCourseReassignId)
      },
      handlePay(record) {
        this.confirmLoading = true
        myCourse.getWholeCourseStudent({ id: record.id }).then(res => {
          this.confirmLoading = false
          this.$router.push('/home/myCoursePay')
          sessionStorage.setItem('wholeCourseId', res.result.wholeCourseId)
          sessionStorage.setItem('wholeId', res.result.wholeId)
          sessionStorage.setItem('courseDate', record.startDate + '~' + record.finishDate)
          sessionStorage.setItem('courseStudentData', JSON.stringify(res.result))
          sessionStorage.setItem('payType', res.result.payType)
          sessionStorage.setItem('wholeAmount', res.result.amount)
        }).catch(() => {
          this.confirmLoading = false
        })
      },
      handleCancel(record) {
        this.$confirm({
          title: '取消选课提示',
          content: '确定取消该选课?',
          okText: '确定',
          cancelText: '取消',
          onOk: () => {
            myCourse.cancelCourse({ id: record.id }).then(res => {
              if (res.status === 200) {
                this.openNotificationWithIcon('success', '成功', '取消选课成功')
                this.$refs.table.refresh(true)
              } else {
                this.openNotificationWithIcon('error', '失败', '取消选课失败')
                this.$refs.table.refresh(true)
              }
            })
          }
        })
      }
    },
    created() {
      Promise.all([
        getListByCode({ dictCode: this.dictCode }).then(res => {
          this.options = { ...this.options, ...res.result.dictDefine }
        })
      ])
    }

  }
</script>
<style lang="less">
  .my-course {
    .table-btn {
      margin: 0 0.0375rem;
    }

  }
</style>
